@if (inline()) {
  <div class="informe-inline">
    <div class="informe-inline__bar">
      <span class="informe-inline__title">Informe del siniestro</span>
      @if (pdfSrcUrl()) {
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="downloadPdf()">
          <i class="fas fa-download me-1"></i> Descargar
        </button>
      }
    </div>
    <div class="informe-inline__body">
      @if (isGeneratingPdf()) {
        <div class="informe-inline__loading">
          <div class="spinner-border text-primary mb-3" role="status"></div>
          <p class="mb-0 small text-muted">Generando informe…</p>
        </div>
      } @else if (pdfSrcUrl()) {
        <iframe [src]="pdfSrcUrl()" title="Informe de siniestro"></iframe>
      } @else {
        <div class="informe-inline__loading">
          <p class="mb-0 small text-muted">El informe no está disponible.</p>
        </div>
      }
    </div>
  </div>
}

<ng-template #pdfPreviewModal let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    @if (!isGeneratingPdf() && pdfSrcUrl()) {
      <a [href]="pdfSrcUrl()" class="btn btn-outline-success btn-sm" target="_blank">
        <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
      </a>
    }
    <span (click)="d('Cross click')" type="button" class="btn-close bt-xs ms-auto" data-dismiss="modal" tabindex="8"></span>
  </div>
  <div class="modal-body p-0 d-flex align-items-center justify-content-center" style="min-height: 400px; background-color: #f8f9fa;">
    @if (isGeneratingPdf()) {
      <div class="text-center p-5">
        <div class="spinner-border text-danger mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
        <h5 class="text-dark font-weight-bold">Consolidando Informe</h5>
        <p class="text-muted small">Cargando evidencias gráficas y documentos adjuntos...</p>
      </div>
    }
    @if (!isGeneratingPdf() && pdfSrcUrl()) {
      <iframe [src]="pdfSrcUrl()" style="width: 100%; height: 650px; border: none;"></iframe>
    }
  </div>
</ng-template>

<div style="display: none;">
  <table id="informe-header-table" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a;">
    <tbody>
      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          1. SOCIO / PROPIETARIO
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Nombre</td>
        <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ party()?.names }} {{ party()?.lastNames }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">RUT</td>
        <td style="padding: 8px; font-size: 9pt;">{{ party()?.rut }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Tipo de socio</td>
        <td style="padding: 8px; font-size: 9pt;">{{ findGroup(party()?.groupSlug) }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Entidad</td>
        <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ party()?.entityCode }} - {{ getEntityName(party()?.entityCode) }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo</td>
        <td style="padding: 8px; font-size: 9pt;">{{ party()?.mail || 'No registrado' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Móvil</td>
        <td style="padding: 8px; font-size: 9pt;">{{ party()?.mobileNumber || 'No registrado' }}</td>
      </tr>

      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          2. VEHÍCULO DEL SOCIO
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Patente</td>
        <td style="padding: 8px; font-size: 9pt;">{{ claim()?.vehicle?.plate || 'N/A' }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Año</td>
        <td style="padding: 8px; font-size: 9pt;">{{ vehicleYear }}</td>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6;">
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Marca / modelo</td>
        <td style="padding: 8px; font-size: 9pt;">{{ getPdfVehicleDesc() }}</td>
        <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Valor comercial</td>
        <td style="padding: 8px; font-size: 9pt;">{{ vehicleCommercialValue }}</td>
      </tr>

      @if (getPdfFieldValue('claimType') === 'ACCIDENT_THIRD_PARTY') {
        <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
          <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
            2.1 TERCERO AFECTADO
          </th>
        </tr>
        <tr style="border-bottom: 1px solid #DEE2E6;">
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Conductor</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyDriverName') }}</td>
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">RUT / licencia</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyLicense') }} (Clase {{ getPdfFieldValue('thirdPartyLicenseClass') || 'N/A' }})</td>
        </tr>
        <tr style="border-bottom: 1px solid #DEE2E6;">
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Propietario</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyOwnerName') }}</td>
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Teléfono</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyPhone') || 'N/A' }}</td>
        </tr>
        <tr style="border-bottom: 1px solid #DEE2E6;">
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Patente / vehículo</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyPlate') }} — {{ getPdfThirdPartyVehicleDesc() }}</td>
          <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Seguro / responsabilidad</td>
          <td style="padding: 8px; font-size: 9pt;">{{ getPdfFieldValue('thirdPartyHasInsurance') ? 'Con seguro' : 'Sin seguro' }} · {{ getPdfFieldValue('thirdPartyTookResponsibility') ? 'Asumió responsabilidad' : 'No asumió' }}</td>
        </tr>
      }

      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          {{ details.length > 0 ? '3. CONSOLIDADO DE DAÑOS Y MONTOS' : '3. RESUMEN DE PRESUPUESTO' }}
        </th>
      </tr>
      @if (details.length > 0) {
        <tr style="border-bottom: 1px solid #DEE2E6; background-color: #e5e6e6">
          <td style="font-weight: bold; padding: 8px; font-size: 9pt; width: 18%;">Fecha</td>
          <td style="font-weight: bold; padding: 8px; font-size: 9pt; width: 32%;">Lugar</td>
          <td style="font-weight: bold; padding: 8px; font-size: 9pt; width: 32%;">Daño</td>
          <td style="font-weight: bold; padding: 8px; font-size: 9pt; width: 18%; text-align: right;">Monto</td>
        </tr>
        @for (det of details; track $index) {
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="padding: 8px; font-size: 9pt;">{{ formatDate(det.dateOfLoss) }}</td>
            <td style="padding: 8px; font-size: 9pt;">{{ det.geographicLocation || 'N/A' }}</td>
            <td style="padding: 8px; font-size: 9pt;">{{ truncateWords(det.description, 18) }}</td>
            <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber((det.totalCost && det.totalCost > 0) ? det.totalCost : (isTotalLoss ? currentVehicleValue : 0)) }}</td>
          </tr>
        }
        <tr style="background-color: #e5e6e6; font-weight: bold;">
          <td colspan="3" style="padding: 8px; font-size: 9pt; text-align: right;">Total bruto de daños</td>
          <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ getTotalDetailsSum().toLocaleString('es-CL') }}</td>
        </tr>
        <tr style="background-color: #f8d7da; color: #842029;">
          <td colspan="3" style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">Deducible a cargo del socio</td>
          <td style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">${{ totalDeductible.toLocaleString('es-CL') }}</td>
        </tr>
        <tr style="background-color: #d1e7dd; color: #0f5132;">
          <td colspan="3" style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">Neto a reembolsar por FPV</td>
          <td style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">${{ netReimbursement.toLocaleString('es-CL') }}</td>
        </tr>
      } @else {
        <tr style="border-bottom: 1px solid #DEE2E6; background-color: #f8f9fa;">
          <td style="font-weight: bold; padding: 8px; font-size: 9pt;">Ítem</td>
          @if (!isTotalLoss) {
            <td style="font-weight: bold; padding: 8px; font-size: 9pt; text-align: right;">Mano de obra</td>
            <td style="font-weight: bold; padding: 8px; font-size: 9pt; text-align: right;">Repuestos</td>
          }
          <td style="font-weight: bold; padding: 8px; font-size: 9pt; text-align: right;">Total presupuestado</td>
        </tr>
        <tr style="border-bottom: 1px solid #DEE2E6;">
          <td style="padding: 8px; font-size: 9pt;">Presupuesto general</td>
          @if (!isTotalLoss) {
            <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(getPdfFieldValue('laborCost')) }}</td>
            <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(getPdfFieldValue('partsCost')) }}</td>
          }
          <td style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">${{ formatNumber(getPdfFieldValue('totalCost')) }}</td>
        </tr>
      }

      <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
        <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
          4. HISTORIA DE APROBACIÓN
        </th>
      </tr>
      <tr style="border-bottom: 1px solid #DEE2E6; background-color: #f8f9fa;">
        <td style="font-weight: bold; padding: 8px; font-size: 8pt;">Paso</td>
        <td style="font-weight: bold; padding: 8px; font-size: 8pt;">Resultado</td>
        <td style="font-weight: bold; padding: 8px; font-size: 8pt;">Responsable</td>
        <td style="font-weight: bold; padding: 8px; font-size: 8pt;">Fecha / nota</td>
      </tr>
      @for (row of approvalMilestones; track $index) {
        <tr style="border-bottom: 1px solid #DEE2E6;">
          <td style="padding: 8px; font-size: 9pt; font-weight: bold;">{{ $index + 1 }}. {{ row.step }}</td>
          <td style="padding: 8px; font-size: 9pt;">{{ row.result }}</td>
          <td style="padding: 8px; font-size: 9pt;">{{ row.actor }}</td>
          <td style="padding: 8px; font-size: 8pt;">{{ row.date }}@if (row.note) {<br>{{ row.note }} }</td>
        </tr>
      }

      @if (reimbursement(); as item) {
          <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
            <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
              5. DETALLE DE PAGO / TRANSFERENCIA
            </th>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Estado del pago</td>
            <td style="padding: 8px; font-size: 9pt;">{{ getReimbursementStatusLabel() }}</td>
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Periodo contable</td>
            <td style="padding: 8px; font-size: 9pt;">{{ item.year }}/{{ item.period }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">N° transacción</td>
            <td style="padding: 8px; font-size: 9pt;">{{ item.transactionNumber || '—' }}</td>
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Fecha de pago</td>
            <td style="padding: 8px; font-size: 9pt;">{{ formatPaidAt(item.paidAt) }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Destino</td>
            <td style="padding: 8px; font-size: 9pt;">{{ getTransferDestinationLabel() }}</td>
            @if (item.request?.commissionDecision?.gloss) {
              <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Acta / voto</td>
              <td style="padding: 8px; font-size: 9pt;">{{ item.request.commissionDecision.gloss }}</td>
            }
          </tr>
         
          <tr style="background-color: #d1e7dd; color: #0f5132; font-weight: bold;">
            <td colspan="3" style="padding: 8px; font-size: 9pt; text-align: right;">Monto pagado (neto)</td>
            <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(item.amount) }}</td>
          </tr>
      }
    </tbody>
  </table>
</div>

<div style="display: none;">
  @if (details.length > 0) {
    @for (det of details; track $index) {
      <table [id]="'informe-detail-table-' + $index" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a; margin-top: 20px;">
        <tbody>
          <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
            <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
              {{ detailSectionPrefix }}.{{ $index + 1 }} DAÑO {{ $index + 1 }} — {{ formatDate(det.dateOfLoss) }}
            </th>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt; width: 18%;">Fecha</td>
            <td style="padding: 8px; font-size: 9pt; width: 32%;">{{ formatDate(det.dateOfLoss) }}</td>
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt; width: 18%;">Lugar</td>
            <td style="padding: 8px; font-size: 9pt; width: 32%;">{{ det.geographicLocation || 'N/A' }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Conductor</td>
            <td style="padding: 8px; font-size: 9pt;">{{ getDriverFormatted(det) }}</td>
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Negligencia</td>
            <td style="padding: 8px; font-size: 9pt;">{{ det.isNegligence ? 'Sí' : 'No' }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Descripción</td>
            <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ det.description || 'N/A' }}</td>
          </tr>
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Partes afectadas</td>
            <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ getPartsFormatted(det) }}</td>
          </tr>
          @if (!isTotalLoss) {
            <tr style="border-bottom: 1px solid #DEE2E6;">
              <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Mano de obra</td>
              <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(det.laborCost) }}</td>
              <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Repuestos</td>
              <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(det.partsCost) }}</td>
            </tr>
          }
          <tr style="border-bottom: 1px solid #DEE2E6;">
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Deducible de este daño</td>
            <td style="padding: 8px; font-size: 9pt; text-align: right;">${{ formatNumber(det.deductible) }}</td>
            <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Total del daño</td>
            <td style="padding: 8px; font-size: 9pt; text-align: right; font-weight: bold;">${{ formatNumber(det.totalCost) }}</td>
          </tr>
        </tbody>
      </table>
    }
  }
</div>
